import React, { Component } from 'react'
import { Row, Col, Form, Input } from 'antd'

type UserFormProps = {
  withPassword?: boolean
}

export default class UserForm extends Component<UserFormProps> {
  static defaultProps = {
    withPassword: true
  }

  render() {
    const { withPassword } = this.props

    return (
      <>
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="First Name"
              name="first_name"
              rules={[
                {
                  required: true,
                  message: 'Required field'
                }
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Last Name"
              name="last_name"
              rules={[
                {
                  required: true,
                  message: 'Required field'
                }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Required field'
                }
              ]}
            >
              <Input />
            </Form.Item>

            {
              withPassword ? (
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: 'Required field'
                    }
                  ]}
                >
                  <Input />
                </Form.Item>
              ) : null
            }
          </Col>
        </Row>
      </>
    )
  }
}
